export const NotificationsConstants = {
    GET_NOTIFICATIONS: 'GET_NOTIFICATIONS',
    NEW_NOTIFICATION: 'NEW_NOTIFICATION',
    NOTIFICATIONS_LOADING: 'NOTIFICATIONS_LOADING',
    MARK_NOTIFICATION_READ: 'MARK_NOTIFICATION_READ',
    MARK_NOTIFICATION_READ_ERROR: 'MARK_NOTIFICATION_READ_ERROR',
}